module.exports = __webpack_public_path__ + "img/edit-information-hover.7ca87b8a.svg";